import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('warehouse?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('warehouse/show/'+id);
    },    
    create(params) {
        return Service().post('warehouse/create', params);
    },
    update(id, params) {
        return Service().post('warehouse/update/'+id, params);
    },
    delete(id) {
        return Service().post('warehouse/delete/'+id);
    }
}